import "./hippodrome.css";
import {Swiper, SwiperSlide} from "swiper/react";
import {useAvailableHippodromes, useDailyRaces} from "features/bulletin/bulletin.store";
import {Hippodrome} from "../../models/bulletin.models";
import React, {useEffect} from "react";
import {getDateHumanize, useForceUpdate} from "../../services/misc.functions";
import {Link, useLocation} from "react-router-dom";
import paths from "../../paths";
import {homeHippodrome, homeHippodromeSubject, path} from "../../store/misc.store";
import {Navigation, Pagination} from "swiper/modules";
import {isMobile} from "../../App";
import redHorse from "../../assets/img/kirmiziat.png";
import blackHorse from "../../assets/img/siyahat.png";

export function HippodromeWidget() {
    const forceUpdate = useForceUpdate();
    const {pathname} = useLocation();
    const dailyRaces = useDailyRaces();
    const hippodromes = useAvailableHippodromes();

    useEffect(() => {
        if (!homeHippodrome?._id && dailyRaces.length > 0) {
            changeSelectedHippodrome(dailyRaces[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dailyRaces]);

    const changeSelectedHippodrome = (hippodrome: any) => {
        Object.assign(homeHippodrome, hippodrome);
        homeHippodromeSubject.next(hippodrome);
        forceUpdate();
    };

    // fixme ana sayfa hariç görünmemeli
    useEffect(() => {
        forceUpdate();
    }, [pathname]);

    if (path.root !== "/") {
        return <></>;
    }

    return (
        <div className="container hippodrome-container p-0">
            <div className="hippodrome-widgets">
                {dailyRaces.length === 0 && (
                    <>
                        <Swiper
                            spaceBetween={isMobile ? 5 : 10}
                            modules={[Navigation, Pagination]}
                            navigation={
                                isMobile
                                    ? false
                                    : {
                                        prevEl: ".prev",
                                        nextEl: ".next",
                                    }
                            }
                            pagination={isMobile ? {clickable: true} : false}
                            onSlideChange={(swiper: any) => {
                                if (isMobile) {
                                    changeSelectedHippodrome(hippodromes[swiper.activeIndex]);
                                }
                            }}
                            breakpoints={{
                                // when window width is >= 320px
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                960: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                },
                                // when window width is >= 640px
                                1280: {
                                    slidesPerView: 5,
                                    spaceBetween: 10,
                                },
                            }}
                        >
                            {[...Array(6)].map((_x, i) => (
                                <SwiperSlide key={`skeleton-${i}`}>
                                    <div className={`item skeleton`}>
                                        <h2>
                                            <span></span>
                                        </h2>
                                        <div className="description">
                                            <div>
                                                <span></span>
                                                <span></span>
                                            </div>
                                            <div>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </>
                )}

                <Swiper
                    spaceBetween={isMobile ? 5 : 10}
                    modules={[Navigation, Pagination]}
                    navigation={
                        isMobile
                            ? false
                            : {
                                prevEl: ".prev",
                                nextEl: ".next",
                            }
                    }
                    pagination={isMobile ? {clickable: true} : false}
                    onSlideChange={(swiper: any) => {
                        if (isMobile) {
                            changeSelectedHippodrome(hippodromes[swiper.activeIndex]);
                        }
                    }}
                    breakpoints={{
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                        },
                        960: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                        },
                        // when window width is >= 640px
                        1280: {
                            slidesPerView: 5,
                            spaceBetween: 10,
                        },
                    }}
                >
                    {dailyRaces.map((hippodrome: Hippodrome, keyHippodrome: number) => {
                            return (
                                <SwiperSlide key={`hippodrome-widget-slider-${keyHippodrome}`}>
                                    <div
                                        className={`item d-flex cursor-pointer ${homeHippodrome._id === hippodrome._id ? "active" : ""}`}>
                                        <div className={isMobile ? "w-50" : "w-100"}>
                                            <h2
                                                className={"nowrap-ellipsis"}
                                                onClick={() => {
                                                    changeSelectedHippodrome(hippodrome);
                                                }}
                                            >
                                                {hippodrome.location}
                                                <br/>
                                                {!hippodrome.status && <span
                                                    className="float-end">{getDateHumanize(hippodrome.date)}</span>}
                                                {hippodrome.nextRun && (
                                                    <span>
                            {hippodrome.nextRun.no}. Koşu - {hippodrome.nextRun.time}
                          </span>
                                                )}
                                            </h2>

                                            {!isMobile && homeHippodrome._id === hippodrome._id ? (
                                                <>
                                                    {hippodrome.wager_details.length > 0 ? (

                                                        <>
                                                            {hippodrome.nextRun && hippodrome.nextRun.show_fob ?   <div className={"row mt-2"}>
                                                                <div className={"col-6 pe-1 ps-2"}>
                                                                    <Link to={`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}`} className="btn btn-sm w-100  rounded-1  btn-warning px-1">
                                                                        <div className={"d-flex  align-items-center"}>
                                                                            <img
                                                                                className={"me-1"}
                                                                                alt={"iconFather"}
                                                                                src={redHorse}
                                                                                height={14}
                                                                            />
                                                                            <div className={"d-flex justify-content-center align-items-baseline flex-column fs-8"}>
                                                                                <span className={"lh-sm"}>Müşterek</span>
                                                                                <span className={"lh-sm fw-bold"}>BAHİS YAP</span>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                                <div className={"col-6 pe-2 ps-1"}>
                                                                    <Link to={`${paths.fobBetting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}`} className="btn btn-sm w-100  rounded-1  btn-warning position-relative border-0">
                                                                        <div className="ribbon ribbon-home" style={{width:'52px',height:'35px',borderBottomRightRadius:'6px'}}>
                                                                            <span style={{
                                                                                fontSize: "9px",
                                                                                lineHeight: "1",
                                                                                padding: "2px"
                                                                            }}>YENİ</span>
                                                                        </div>
                                                                        <div className={"d-flex  align-items-center"}>
                                                                            <img
                                                                                className={"me-1"}
                                                                                alt={"iconFather"}
                                                                                src={blackHorse}
                                                                                height={14}
                                                                            />
                                                                            <div className={"d-flex justify-content-center align-items-baseline flex-column fs-8"}>
                                                                                <span className={"lh-sm"}>Sabit Oranlı</span>
                                                                                <span className={"lh-sm fw-bold"}>BAHİS YAP</span>
                                                                            </div>

                                                                        </div>

                                                                    </Link>
                                                                </div>
                                                            </div> :  <Link
                                                                className="btn btn-sm w-100 fw-semibold mt-2 rounded-1 btn-warning"
                                                                to={`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}`}
                                                                onClick={() => {
                                                                    window.scrollTo(0, 0);
                                                                }}
                                                            >
                                                                {getDateHumanize(hippodrome.date) !== 'Yarın' ? "BAHİS YAP" : "PROGRAM"}
                                                            </Link>}
                                                        </>

                                                    ) : (
                                                        <Link
                                                            className="btn btn-sm w-100 fw-semibold mt-2 rounded-1 btn-warning"
                                                            to={`${paths.results.url}/${hippodrome._date}/${hippodrome.keyword.toLowerCase()}/1`}
                                                            onClick={() => {
                                                                window.scrollTo(0, 0);
                                                            }}
                                                        >
                                                            SONUÇLAR
                                                        </Link>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <div
                                                        className="description"
                                                        onClick={() => {
                                                            changeSelectedHippodrome(hippodrome);
                                                        }}
                                                    >
                                                        <Weather hippodrome={hippodrome}></Weather>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        {isMobile && (
                                            <div className="w-50 ps-3">
                                                {hippodrome.wager_details.length > 0 ? (
                                                    <Link
                                                        className="btn btn-sm w-100 fw-semibold mb-0 rounded-1 btn-warning"
                                                        to={`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}`}
                                                        onClick={() => {
                                                            window.scrollTo(0, 0);
                                                        }}
                                                    >
                                                        {getDateHumanize(hippodrome.date) !== 'Yarın' ? "BAHİS YAP" : "PROGRAM"}
                                                    </Link>
                                                ) : (
                                                    <Link
                                                        className="btn btn-sm w-100 fw-semibold mb-0 rounded-1 btn-warning"
                                                        to={`${paths.results.url}/${hippodrome._date}/${hippodrome.keyword.toLowerCase()}/1`}
                                                        onClick={() => {
                                                            window.scrollTo(0, 0);
                                                        }}
                                                    >
                                                        SONUÇLAR
                                                    </Link>
                                                )}
                                                <Link
                                                    className="btn btn-sm w-100 fw-semibold mt-1 mb-1 rounded-1 btn-secondary text-nowrap"
                                                    to={`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}/muhtemeller`}
                                                    onClick={() => {
                                                        window.scrollTo(0, 0);
                                                    }}
                                                >
                                                    MUHTEMELLER / AGF
                                                </Link>
                                                <Link
                                                    className="btn btn-sm w-100 fw-semibold mt-1 mb-1 rounded-1 btn-secondary text-nowrap"
                                                    to={`${paths.statistics.url}/${hippodrome.date.split('T')[0]}/${hippodrome.keyword.toLowerCase()}`}
                                                    onClick={() => {
                                                        window.scrollTo(0, 0);
                                                    }}
                                                >
                                                    İSTATİSTİKLER
                                                </Link>
                                                {/* <Link
                          className="btn btn-sm w-100 fw-semibold mt-0 rounded-1 btn-secondary"
                          to={`${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}/agf`}
                          onClick={() => {
                            window.scrollTo(0, 0);
                          }}
                        >
                          AGF
                        </Link> */}
                                            </div>
                                        )}
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                </Swiper>

                {!isMobile && (
                    <>
                        <div className="swiper-button-prev prev"></div>
                        <div className="swiper-button-next next"></div>
                    </>
                )}
            </div>
        </div>
    );
}

export function Weather(prop: any) {
    const hippodrome = prop.hippodrome;
    return (
        <>
            <div>
        <span>
          Nem: <b>%{hippodrome.weather.humidity}</b>
        </span>
                <span>{hippodrome.nextRun ? <b>{hippodrome.nextRun.distance}m</b> : <br/>}</span>
            </div>
            <div>
        <span>
          Sıcaklık: <b>{hippodrome.weather.temperature}°C</b>
        </span>
                <span>
          <b>{hippodrome.nextRun && hippodrome.nextRun.course}</b>
        </span>
            </div>
        </>
    );
}
